import { render, staticRenderFns } from "./LocaleList.vue?vue&type=template&id=db20eae6&"
import script from "./LocaleList.vue?vue&type=script&lang=js&"
export * from "./LocaleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports